<template>
  <div class="modal_wrap modal_user_info" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <div class="head_title">{{ userInfoProfile.userNickName }}</div>
          <div
            class="head_device"
            v-if="
              userInfoProfile.myDeviceName != '' &&
                userInfoProfile.myTelecomName != ''
            "
          >
            {{ userInfoProfile.myDeviceName }} /
            {{ userInfoProfile.myTelecomName }}
          </div>
        </div>
        <div class="modal_con">
          <div class="modal_info">
            <dl>
              <dt>최근 접속이력</dt>
              <dd
                v-if="
                  userInfoProfile.accessMinute > 0 &&
                    userInfoProfile.accessMinute <= 10
                "
              >
                10분 전
              </dd>
              <dd v-else-if="userInfoProfile.accessMinute <= 30">
                30분 전
              </dd>
              <dd v-else-if="userInfoProfile.accessMinute <= 60">
                1시간 전
              </dd>
              <dd v-else-if="userInfoProfile.accessMinute <= 120">
                2시간 전
              </dd>
              <dd v-else-if="userInfoProfile.accessMinute <= 360">
                6시간 전
              </dd>
              <dd v-else-if="userInfoProfile.accessMinute <= 720">
                12시간 전
              </dd>
              <dd v-else>
                12시간 후
              </dd>
            </dl>
            <!-- <dl>
              <dt>최근 견적요청</dt>
              <dd>{{ chatCnt }}곳</dd>
            </dl> -->
            <dl>
              <dt>관심등록 매장</dt>
              <dd>{{ userInfoProfile.followCnt }}곳</dd>
            </dl>
            <!-- <dl>
              <dt>후기등록 매장</dt>
              <dd>{{ reviewCnt }}곳</dd>
            </dl> -->
            <dl>
              <dt>인터넷 요청횟수</dt>
              <dd>{{ userInfoProfile.internetCommerceCnt }}회</dd>
            </dl>
            <dl>
              <dt>휴대폰 요청횟수</dt>
              <dd>{{ userInfoProfile.mobileRequestCnt }}회</dd>
            </dl>
            <div class="modal_apply_info">
              <div class="title">동일명의&동일주소 인터넷 가입신청 현황</div>
              <div class="info">
                <div class="txt_1">최근 일주일</div>
                <div class="txt_2">
                  {{ userInfoProfile.weeklySameApplyList }}
                </div>
              </div>
              <div class="info">
                <div class="txt_1">최근 한달</div>
                <div class="txt_2">
                  {{ userInfoProfile.monthlySameApplyList }}
                </div>
              </div>
            </div>
            <!-- <div class="modal_place" v-if="userInfoProfile.message != ''">
              <i class="i_place"></i>{{ userInfoProfile.message }}
            </div> -->
            <div class="modal_cur_area" v-if="userInfoProfile.userCurrentArea">
              <i class="i_place"></i>현재 접속지역
              <span>{{ userInfoProfile.userCurrentArea }}</span>
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" v-on:click="$emit('close')">닫기</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions as userMapActions,
  mapState as userMapState,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import { sleep, nativeDeviceInfo } from '@common/lib/common/utils';

export default {
  props: {
    isOpen: Boolean,
    // userId: Number,
    userInfoProfile: Object,
  },
  data() {
    return {
      // isOpen: false,
      // message: '', // 우리동네 일경우 노출
      // userNickName: '',
      // myDeviceName: '',
      // myTelecomName: '',
      // accessMinute: 0, // 최근 접속이력 시간 (10분 전, 30분 전, 1시간 전, 2시간 전, 6시간 전, 12시간 전, 12시간 후)
      // chatCnt: 0, // 최근 상담진행
      // followCnt: 0, // 관심등록 매장
      // reviewCnt: 0, // 후기등록 매장
      // internetCommerceCnt: 0, // 인터넷 요청횟수
      // mobileRequestCnt: 0, // 휴대폰 요청횟수
      // monthlySameApplyList: '',
      // weeklySameApplyList: '',
    };
  },
  name: 'UserInfoModal',
  computed: {},
};
</script>
